import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { Box } from '../../../../../core/models';
import { DialogComponent } from '../../../../../core/models/dialog.data';

@Component({
  selector: 'dbx-add-box-info-dialog',
  templateUrl: './add-box-info-dialog.component.html',
  styleUrl: './add-box-info-dialog.component.scss',
  standalone: true,
  imports: [TranslateModule, MatButton, MatDialogTitle, MatDialogContent, MatDialogActions],
})
export class AddBoxInfoDialogComponent extends DialogComponent<AddBoxInfoDialogComponent> {
  private readonly dialogData = inject<{ box: Box }>(MAT_DIALOG_DATA);

  box = this.dialogData.box;
}
